<template>
    <div id="third-strategy">
        <!--=====================================-->
        <!--=      Strategy Quality Area Start    =-->
        <!--=====================================-->
        <section class="section sunflower bg-color-light-gray pb--80 pb_lg--40 pb_md--20">
            <div class="container">
                <div class="row" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                    <div class="col-lg-12">
                        <div class="about-quality active">
                            <h3 class="sl-number bold mb-2 mt-5">3</h3>
                            <h2 class="title black font-weight-100 mb-2 ml-1">
                                <span class="bold">Transparencia</span> y <span class="bold">trazabilidad</span>
                            </h2>
                        </div>
                    </div>
                </div>
                <!-- ODS -->
                <div class="process-work" data-sal="slide-right" data-sal-duration="1000" data-sal-delay="100">
                    <div class="thumbnail paralax-image">
                        <img :src="getLogo('ods')" alt="Thumbnail">
                    </div>
                    <div class="content">
                        <span class="subtitle primary">Medición del impacto</span>
                        <h3 class="title font-weight-100">Medición del impacto</h3>
                        <p class="black">
                            Cuantificar los impactos ambientales, sociales y económicos, 
                            así como su relación con los Objetivos del Desarrollo 
                            Sostenible (ODS). <router-link :to="{ name: 'impactPage' }" class="rg-a">Conoce más.</router-link>
                        </p>
                    </div>
                </div>
                <!-- CARBON MARK -->
                <!-- <div class="process-work content-reverse" data-sal="slide-left" data-sal-duration="1000" data-sal-delay="100">
                    <div @click.stop="redirectThirdSite('https://www.klimadao.finance/es')" class="thumbnail paralax-image clickable">
                        <img :src="getLogo('carbonmark')" alt="Thumbnail">
                    </div>
                    <div class="content">
                        <span class="subtitle primary">Rendición de cuentas – Visión global (1%).</span>
                        <h3 @click.stop="redirectThirdSite('https://www.klimadao.finance/es')" class="title font-weight-100 clickable">Carbonmark.</h3>
                        <p class="black">
                            Utilizamos los servicios de Carbonmark para comprar los bonos de carbono y utilizar la tecnología blockchain para dar trazabilidad a los retiros permanentes de los bonos.
                            Encuentra nuestros retiros realizados <a @click.stop="redirectThirdSite('https://www.carbonmark.com/retirements/0x80648fa52e86165c0d0a979efc0f4a31543d40b5')"><u>aquí</u></a>.
                        </p>
                    </div>
                </div> -->
                <!-- CARBON MARK -->
                <!-- KLIMADAO -->
                <!-- <div class="process-work content-reverse" data-sal="slide-left" data-sal-duration="1000" data-sal-delay="100">
                    <div @click.stop="redirectThirdSite('https://www.klimadao.finance/es')" class="thumbnail paralax-image clickable">
                        <img :src="getLogo('klimadao')" alt="Thumbnail">
                    </div>
                    <div class="content">
                        <span class="subtitle primary">Rendición de cuentas – Visión global (1%).</span>
                        <h3 @click.stop="redirectThirdSite('https://www.klimadao.finance/es')" class="title font-weight-100 clickable">Klima Infinity.</h3>
                        <p class="black">
                            Utilizamos los servicios de KlimaDAO para comprar los bonos 
                            de carbono y utilizar la tecnología blockchain para dar 
                            trazabilidad a los retiros permanentes de los bonos.
                        </p>
                    </div>
                </div> -->
                <!-- FOR THE PLANET -->
                <div class="process-work content-reverse" data-sal="slide-left" data-sal-duration="1000" data-sal-delay="100">
                    <div @click.stop="redirectThirdSite('https://onepercentfortheplanet.org/')" class="thumbnail paralax-image clickable">
                        <img :src="getLogo('for-the-planet')" alt="Thumbnail">
                    </div>
                    <div class="content">
                        <span class="subtitle primary">Rendición de cuentas – Acción local (1%).</span>
                        <h3 @click.stop="redirectThirdSite('https://onepercentfortheplanet.org/')" class="title font-weight-100 clickable">1% For The Planet.</h3>
                        <p class="black">
                            Nos adherimos a la iniciativa internacional "1% For The Planet" 
                            la cual audita y da certeza de las donaciones que 
                            realizamos.
                            <!-- Encuentra nuestro perfil <a @click.stop="redirectThirdSite('https://directories.onepercentfortheplanet.org/profile/red-girasol')"><u>aquí</u></a>. -->
                        </p>
                    </div>
                </div>
                <!-- CERTIFIED B CORP  https://www.bcorporation.net/ -->
                <div class="process-work" data-sal="slide-right" data-sal-duration="1000" data-sal-delay="100">
                    <div @click.stop="redirectThirdSite('https://www.bcorporation.net/')" class="thumbnail paralax-image clickable">
                        <img :src="getLogo('cc')" alt="Thumbnail">
                    </div>
                    <div class="content">
                        <span class="subtitle primary">Rendición de cuentas – Empresa sostenible.</span>
                        <h3 @click.stop="redirectThirdSite('https://www.bcorporation.net/')" class="title font-weight-100 clickable">B Corp.</h3>
                        <p class="black">
                            Nos encontramos en proceso de certificarnos como una 
                            Empresa B (B Corp), movimiento internacional que busca 
                            impulsar a que los negocios se conviertan una herramienta 
                            de impacto.
                        </p>
                    </div>
                </div>
                <!-- ZOOM -->
                <!-- <div class="process-work content-reverse" data-sal="slide-left" data-sal-duration="1000" data-sal-delay="100">
                    <div class="thumbnail paralax-image">
                        <img :src="getLogo('zoom')" alt="Thumbnail">
                    </div>
                    <div class="content">
                        <span class="subtitle primary">Medición del impacto</span>
                        <h3 class="title font-weight-100">La hora verde.</h3>
                        <p class="black">
                            Espacio abierto por el cual el equipo de RedGirasol 
                            comunicación directa con la comunidad para actualizar .
                        </p>
                    </div>
                </div> -->
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "ThirdStrategy",
    methods: {
        getLogo(name) {
            return `https://cdn.redgirasol.com/nuevo_portal/logos/logo-${name}.png`
        }
    }
}

</script>

<style scoped>
.about-quality .sl-number {
    background: var(--color-primary);
}

.thumbnail {
    width: 25rem;
    height: 25rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
    .thumbnail img {
        max-width: 70%;
    }

.sunflower {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/extras/sunflower-line-vertical-green.png"), url("https://cdn.redgirasol.com/nuevo_portal/extras/sunflower-line-vertical-green-left.png");
    background-repeat: no-repeat;
    background-position-x: right, left;
    background-position-y: 10rem, bottom;
    background-size: 40rem;
}
</style>